import { Helmet } from 'react-helmet';
import Services from './../../Components/Services/Services';
import CallToAction from './../../Components/CallToAction/CallToAction';
import { Box } from '@mui/material';
import useStyles from './Home.Styles';

function Home() {
    const classes = useStyles();
    const canonicalUrl = "https://outdoormoviepros.com";

    return (
        <section>
            <Helmet>
                {/* Core */}
                <title>Outdoor Movie Screen Rental Phoenix AZ | Inflatable Movie Screens</title>
                <meta
                    name="description"
                    content="Professional outdoor movie screen rental in Phoenix AZ. Giant inflatable movie screens with HD projectors, professional sound, and full setup included. Serving Phoenix and surrounding cities."
                />
                <link rel="canonical" href={canonicalUrl} />

                {/* GEO TAGS (Phoenix metro center - long lat) */}
                <meta name="geo.position" content="33.4484;-112.0740" />
                <meta name="geo.placename" content="Phoenix, AZ" />
                <meta name="geo.region" content="US-AZ" />
                <meta name="ICBM" content="33.4484, -112.0740" />

                {/* Voice Search */}
                <meta name="apple-mobile-web-app-capable" content="yes" />
                <meta name="mobile-web-app-capable" content="yes" />

                {/* Open Graph (Minimal Override) */}
                <meta property="og:url" content={canonicalUrl} />
                <meta property="og:title" content="Outdoor Movie Screen Rental Phoenix AZ | Inflatable Movie Screens" />
                <meta
                    property="og:description"
                    content="Professional outdoor movie screen rental in Phoenix AZ. Giant inflatable movie screens with HD projectors, professional sound, and full setup included. Serving Phoenix and surrounding cities."
                />

                {/* Twitter (Minimal Override) */}
                <meta name="twitter:title" content="Outdoor Movie Screen Rental Phoenix AZ | Inflatable Movie Screens" />
                <meta
                    name="twitter:description"
                    content="Professional outdoor movie screen rental in Phoenix AZ. Giant inflatable movie screens with HD projectors, professional sound, and full setup included. Serving Phoenix and surrounding cities."
                />

                {/* JSON-LD: WebPage + ItemList (react-snap safe) */}
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@graph": [
                            {
                                "@type": "WebPage",
                                "@id": `${canonicalUrl}#webpage`,
                                "url": canonicalUrl,
                                "name": "Outdoor Movie Screen Rental Phoenix AZ | Inflatable Movie Screens",
                                "description": "Professional outdoor movie screen rental in Phoenix AZ. Giant inflatable movie screens with HD projectors, professional sound, and full setup included. Serving Phoenix and surrounding cities.",
                                "isPartOf": { "@id": "https://outdoormoviepros.com/#website" },
                                "about": { "@id": "https://outdoormoviepros.com/#business" },
                                "breadcrumb": {
                                    "@type": "BreadcrumbList",
                                    "itemListElement": [
                                        {
                                            "@type": "ListItem",
                                            "position": 1,
                                            "name": "Home",
                                            "item": canonicalUrl
                                        }
                                    ]
                                }
                            },
                            {
                                "@type": "ItemList",
                                "name": "Outdoor Movie Pros Services",
                                "itemListElement": [
                                    {
                                        "@type": "ListItem",
                                        "position": 1,
                                        "item": {
                                            "@type": "Service",
                                            "name": "Outdoor Movie Nights",
                                            "description": "Backyard & park movie rentals with giant inflatable screens, HD projector, pro sound, full setup and on-site tech.",
                                            "image": "https://outdoormoviepros.com/images/giant-screen.webp",
                                            "url": "https://outdoormoviepros.com/movie-nights-options"
                                        }
                                    },
                                    {
                                        "@type": "ListItem",
                                        "position": 2,
                                        "item": {
                                            "@type": "Service",
                                            "name": "Concessions & Add-Ons",
                                            "description": "Popcorn, cotton candy, cold drinks, generators, and staffed service for movie nights.",
                                            "image": "https://outdoormoviepros.com/images/concessions-image.webp",
                                            "url": "https://outdoormoviepros.com/concessions-options"
                                        }
                                    },
                                    {
                                        "@type": "ListItem",
                                        "position": 3,
                                        "item": {
                                            "@type": "Service",
                                            "name": "Ice Cream & Coffee Food Truck",
                                            "description": "Sundae bar and barista coffee truck for events — corporate, schools, festivals, and private parties.",
                                            "image": "https://outdoormoviepros.com/images/ice-cream-truck.webp",
                                            "url": "https://outdoormoviepros.com/ice-cream-food-truck"
                                        }
                                    }
                                ]
                            }
                        ]
                    })}
                </script>
            </Helmet>
            <main>
                <Box className={classes.titleBox}>
                    <h1 className={classes.title}>
                        Outdoor Movie Screen Rental in Phoenix, AZ 
                        {/* Accessible, SEO-aligned */}
                        <span className="sr-only">
                            Inflatable outdoor movie screen rentals with HD projection and professional audio in Phoenix, AZ and nearby cities.
                        </span>
                    </h1>
                    <h2 className={classes.subTitle}>
                        Giant inflatable screens with HD projector, pro sound, full delivery, setup & teardown. Serving Phoenix, Scottsdale, Mesa, Chandler, Gilbert, Tempe, Glendale, Peoria & more.
                    </h2>
                </Box>

                <Services />
                <CallToAction />
            </main>
        </section>
    );
}

export default Home;
